import VectorModule from './VectorModule';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import { baseProjection, targetProjection } from '../../projection';

class PointModule extends VectorModule {
  // 단일 피쳐 생성 (속성 정보 추가)
  public createPointFeature(data: any) {
    const { x, y, z, pitCde, pointId, ptNum, facilityKind } = data;
    let geometry = [y, x];

    const feature = new Feature({
      id: 'point',
      geometry: new Point(geometry),
      properties: {
        ...data,
      },
    });
    feature.getGeometry()?.transform(targetProjection, baseProjection);
    return feature;
  }

  // 피쳐 배열 리턴
  public createPointFeatures(datas: any[]) {
    return datas?.map((data) => {
      return this.createPointFeature(data);
    });
  }
}

export default PointModule;
